package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.compose.ui.modifiers.color

val MapStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .maxWidth(800.px)   // widened
            .height(280.px)     // mobile
            .border(0.px)
            .borderRadius(12.px)
            .boxShadow(
                offsetX = 0.px, offsetY = 2.px, blurRadius = 8.px,
                color = Color.rgba(0, 0, 0, 0.08f)
            )
    }
    Breakpoint.MD {
        Modifier.height(450.px)
    }
}